import { render, staticRenderFns } from "./Energy.vue?vue&type=template&id=2dfd47c6"
import script from "./Energy.vue?vue&type=script&lang=js"
export * from "./Energy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports